import { Box, Card, Flex, Heading, Tag, Text } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

import type { MyDispositionType } from '../types';

type Props = {
  disposition: MyDispositionType,
};

const CustomerCard = ({ disposition }: Props) => {
  const navigate = useNavigate();
  const { executionId } = useParams();

  const onClickCustomer = async (customerInteractionId: string) => {
    try {
      const response = await api.get(`/campaign_execution/${executionId}/current/${customerInteractionId}`);

      if (response.status === 200) {
        navigate(`/painel/atendimentos/${executionId}/cliente`, {
          state: {
            customer: response.data.customer,
            customerInteractionId: response.data.id,
            dispositions: response.data.dispositions,
            funnelId: response.data.sales_funnel_step_id,
          },
        });
      }
    } catch (error) {
      toast.error('Erro ao continuar atendimento');
      datadogRum.addError(new Error('Fail to get current customer interaction'), {
        error,
        executionId,
        customerInteractionId,
      });
    }
  };

  return (
    <Box position="relative">
      <Card.Root
        size="sm"
        variant="elevated"
        bg="grayscale.fg"
        mt={4}
        pl={4}
        pr={14}
        py={3}
        display="flex"
        justifyContent="center"
        _hover={{ bg: 'bg.muted' }}
        cursor="pointer"
        onClick={() => onClickCustomer(disposition.id)}
      >
        <Flex
          gap={{ base: 1, md: 2 }}
          flexDirection={{ base: 'column', lg: 'row' }}
          mb={{ base: 1, md: 0 }}
        >
          <Heading
            size="md"
            color={'fg.default'}
          >
            {disposition.customer.name}
          </Heading>
          <Flex gap={1} flexWrap="wrap">
            {disposition.customer.tags.map((tag) => (
              <Tag.Root key={tag} size="md" bg="argos.fg" color="grayscale" fontWeight={600}>
                <Tag.Label>{tag}</Tag.Label>
              </Tag.Root>
            ))}
          </Flex>
        </Flex>
        <Text color="fg.muted">
          {disposition.customer.portfolio.name}
        </Text>
      </Card.Root>
    </Box>
  );
};

export default CustomerCard;
